/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as t from "react";
import { classNames as u } from "@progress/kendo-react-common";
import { TREELIST_ROW_INDEX_ATTRIBUTE as x } from "../constants/index.mjs";
const k = t.forwardRef((e, o) => {
  const { isSelected: i, rowHeight: a, isAltRow: r, expanded: l, ariaRowIndex: c, level: d, ariaSetSize: s, ariaPosInSet: m } = e, w = u(
    "k-table-row",
    "k-master-row",
    {
      "k-selected": i,
      "k-alt": r
    }
  ), R = t.useMemo(
    () => a !== void 0 ? { height: a + "px" } : void 0,
    [a]
  ), n = /* @__PURE__ */ t.createElement(
    "tr",
    {
      onClick: e.onClick,
      onDoubleClick: e.onDoubleClick,
      onContextMenu: e.onContextMenu,
      className: w,
      style: R,
      ref: o,
      "aria-expanded": l,
      role: "row",
      "aria-rowindex": c,
      "aria-level": d.length,
      "aria-posinset": m,
      "aria-setsize": s,
      [x]: e.rowIndex
    },
    e.children
  );
  return /* @__PURE__ */ t.createElement(t.Fragment, null, e.render ? e.render.call(void 0, n, e) : n);
});
k.displayName = "KendoReactTreeListRow";
export {
  k as TreeListRow
};
